export const territoriesConstants = {
  GET_ROLLING_MONTHS_REVENUE_REQUEST: 'GET_ROLLING_MONTHS_REVENUE_REQUEST',
  GET_ROLLING_MONTHS_REVENUE_SUCCESS: 'GET_ROLLING_MONTHS_REVENUE_SUCCESS',
  GET_ROLLING_MONTHS_REVENUE_FAILURE: 'GET_ROLLING_MONTHS_REVENUE_FAILURE',
  GET_TERRITORIES_REQUEST: 'GET_TERRITORIES_REQUEST', 
  GET_TERRITORIES_SUCCESS: 'GET_TERRITORIES_SUCCESS',
  GET_TERRITORIES_FAILURE: 'GET_TERRITORIES_FAILURE',
  DELETE_SHARED_PAGE_REQUEST: 'DELETE_SHARED_PAGE_REQUEST',
  DELETE_SHARED_PAGE_SUCCESS: 'DELETE_SHARED_PAGE_SUCCESS',
  DELETE_SHARED_PAGE_FAILURE: 'DELETE_SHARED_PAGE_FAILURE'
}